<table>
	<thead>
		<tr>
			<!-- TO-DO: comprobar la ordenación -->
			<th class="subtable date sortable" style="max-width: 3em;" (click)="toOrderBy('x=> x.fechaIns', 'fechaIns')">
				{{ 'global.fecha.insercionMedium' | translate}}
				<div class="sortable-icons">
                    <i [ngClass]="getIcon('x=> x.fechaIns', 'fechaIns')"></i>
                </div>
			</th>
			<th class="subtable centered sortable" (click)="toOrderBy('x=> x.estadoId', 'estado')">
				{{ 'global.estado' | translate}}
				<div class="sortable-icons">
                    <i [ngClass]="getIcon('x=> x.estadoId', 'estado')"></i>
                </div>
			</th>
			<th class="subtable string sortable" (click)="toOrderBy('x=> x.observacion', 'observacion')">
				{{ 'mantenimientoCertificados.table.observations' | translate}}
				<div class="sortable-icons">
					<i [ngClass]="getIcon('x=> x.observacion', 'observacion')"></i>
				</div>
			</th>
			<th class="subtable action"></th>
		</tr>
	</thead>
	<tbody *ngFor="let estado of estados; let i = index">
		<tr>
			<td class="date">{{ estado.fechaIns | date: 'shortDate' : undefined : defaultLanguage }}</td>
			<td class="string centered">
				<!-- 1: Pendiente, 2: Concedido, 3: Retirado, 4: Cancelado, 5: Expirado -->
				<i class="far fa-check-circle" [ngStyle]="getCheckIconColor(estado.estadoId)" [title]="getCheckIconTitle(estado.estadoId)"></i>
			</td>
			<td class="string" *ngIf="editedIndex !== i">{{ estado.observaciones }}</td>
			<ng-container *ngIf="editedIndex === i" [formGroup]="editForm">
				<td class="entry" style="text-align: left;">
					<input type="text" id="observation" formControlName="observation" style="width: 100%;">
				</td>
			</ng-container>
			<td class="multi-actions">
				<i class="fas fa-pencil-alt" *ngIf="editedIndex !== i" app-click-stop-propagation (click)="openObservationStatus(estado.observaciones, i)" title="{{'titles.editar' | translate}}"></i>
				<i class="fas fa-save" *ngIf="editedIndex === i" (click)="updateObservationStatus(estado.certificadoExpedicionEstadoHistId)" title="{{'titles.guardar' | translate}}"></i>
				<i class="fas fa-times" *ngIf="editedIndex === i" (click)="cancelUpdate()" title="{{'titles.cancelar' | translate}}"></i>
			</td>
		</tr>
	</tbody>
	<tfoot *ngIf="!estados || (estados && estados.length < 1)">
		<tr>
			<td colspan="4">
				{{ 'global.noContent' | translate }}
			</td>
		</tr>
	</tfoot>
</table>
<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>

<app-paginator 
    *ngIf="estados && estados.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
    [totalItems]="totalItems" [visiblePages]="visiblePages" 
    (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)">
</app-paginator>